import { getSharedConfig } from "../../createSharedConfig"
import { getBuyRequestMeta, getSimpleForBuyRequest } from "@/js/helpers/buy-request"
import { RACK_COLORS } from "@/js/pages/product/rackbuilder/constants"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getCommonAccessorySelections, getBackSelection, getFrontSelection, getJCupSelection, getDepthSelection, getPlateStorageSelection, getBandPegSelection } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"

export function createLatLowRowAddonConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = findBundleProduct(rogue, buyRequest, 'rack') || getSimpleForBuyRequest(buyRequest, rogue)
  const functionalTrainer = findBundleProduct(rogue, buyRequest, 'trainer')

  const sharedConfig = getSharedConfig(rogue, buyRequest)

  const isSlimRack = rack?.attributes?.rack_depth === '14"'
  const isHalfRack = rack?.attributes?.rack_size === '4'

  const { trolleySelection, lowRowSelection, latBarSelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  const latAndLowRowOptions = {
    latBarSelection,
    lowRowSelection,
    resistanceType : functionalTrainer?.attributes?.edition,
    isAddon        : true,
    isSlimRack,
    stringers      : findBundleProduct(rogue, buyRequest, 'stringer', true)?.name,
    rackSize       : String(functionalTrainer?.attributes?.rack_size),
  }

  return {
    ...sharedConfig,
    back            : isHalfRack ? '' : getBackSelection(rogue, buyRequest, meta) || 'nameplate',
    front           : isHalfRack ? 'crossmember top 4' : getFrontSelection(rogue, buyRequest, meta),
    color           : RACK_COLORS['Rogue Red'],
    edition         : 'lat',
    jcup            : getJCupSelection(rogue, buyRequest),
    depth           : getDepthSelection(rack, meta),
    halfRack        : isHalfRack || undefined,
    sixPost         : !isHalfRack,
    plateStorage    : getPlateStorageSelection(rogue, buyRequest),
    bandPegs        : getBandPegSelection(rogue, buyRequest),
    ftShrouds       : Boolean(functionalTrainer?.attributes?.rig_or_wm === 'Yes'),
    spotterArms     : isHalfRack ? undefined : getAccessoryQuantity(rogue, buyRequest, 'spotter arms'),
    frontStabilizer : isHalfRack && findBundleProduct(rogue, buyRequest, 'feet', true) !== undefined,
    trolleySelection,
    latBarSelection,
    lowRowSelection,
    latAndLowRowOptions,
    isAddon         : true,
  }
}
